import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { api } from '@core/api';
import { useTenant } from '@core/tenant';

export interface Reservation {
  id: number;
  resDate: string;
  resTime: string;
  partySize: number;
  serviceType: string;
  inWaitingList: boolean;
  inRequestBookintList: boolean;
  waitingListHash?: string;
  intermediary?: string;
  guestName?: string;
  type?: string;
  menuId?: number;
}

export const userReservationsKeys = {
  all: ['userReservations'] as const,
  byRestaurant: (restaurantId: number) =>
    [...userReservationsKeys.all, restaurantId] as const,
};

async function fetchUserReservations(
  lang: string,
  restaurantId: number
): Promise<Reservation[]> {
  const response = await api.get<Reservation[]>(
    `/api/${lang}/get-user-reservations`,
    { params: { restaurantId } }
  );
  return response ?? [];
}

export function useUserReservations() {
  const { restaurant } = useTenant();
  const { i18n } = useTranslation();
  const lang = i18n.language || 'es';
  const restaurantId = restaurant?.id;

  return useQuery({
    queryKey: userReservationsKeys.byRestaurant(restaurantId!),
    queryFn: () => fetchUserReservations(lang, restaurantId!),
    enabled: !!restaurantId,
    staleTime: 2 * 60 * 1000,
    gcTime: 5 * 60 * 1000,
    refetchOnMount: 'always',
  });
}
